import { usePlausible as nextUsePlausible } from 'next-plausible'
import { useCallback } from 'react'

export function usePlausibleChecked() {
  const plausible = nextUsePlausible()
  return useCallback<typeof plausible>(
    (...args) => {
      try {
        plausible(...args)
      } catch (e) {
        console.log('send event failed: ', e)
      }
    },
    [plausible],
  )
}
